module.exports = __webpack_public_path__ + "img/logo2.081a91ac.png";